"use strict";

function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CustomData = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var CustomData = /*#__PURE__*/function () {
  function CustomData(a) {
    _classCallCheck(this, CustomData);
    _defineProperty(this, "_status", void 0), _defineProperty(this, "index", void 0), _defineProperty(this, "value", void 0), _defineProperty(this, "isIdentifier", void 0), this.index = a;
    for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
    this.value = c, this._status = _types2.TrackingStatus.Unsent, this.isIdentifier = !1;
  }
  return _createClass(CustomData, [{
    key: "url",
    get: function get() {
      if ("number" != typeof this.index) return "";
      var a = _toConsumableArray(new Set(this.value));
      var b = {};
      if (a.forEach(function (a) {
        b[a] = 1;
      }), !Object.keys(b).length) return "";
      var c = "";
      return this.isIdentifier && (c = _requester.UrlParameter.MappingIdentifier + "true"), _requester.UrlEventType.CustomData + _requester.UrlParameter.Index + this.index + _requester.UrlParameter.ValuesCountMap + encodeURIComponent(JSON.stringify(b)) + _requester.UrlParameter.Overwrite + "true" + c;
    }
  }, {
    key: "data",
    get: function get() {
      return {
        index: this.index,
        value: this.value,
        type: _types.KameleoonData.CustomData,
        isIdentifier: this.isIdentifier,
        status: this.status
      };
    }
  }, {
    key: "status",
    get: function get() {
      return this._isMappingIdentifier ? _types2.TrackingStatus.Unsent : this._status;
    },
    set: function set(a) {
      this._status = a;
    }
  }, {
    key: "_isMappingIdentifier",
    set: function set(a) {
      this.isIdentifier = a;
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.index,
        c = a.value,
        d = a.status,
        e = a.isIdentifier,
        f = _construct(CustomData, [b].concat(_toConsumableArray(c)));
      return f.status = d, f._isMappingIdentifier = e, f;
    }
  }, {
    key: "_updateFromVisit",
    value: function _updateFromVisit(a, b) {
      var c;
      if (null !== (c = a.customDataEvents) && void 0 !== c && c.length) for (var _c = a.customDataEvents.length - 1; 0 <= _c; _c--) {
        var _a$customDataEvents$_ = a.customDataEvents[_c].data,
          d = _a$customDataEvents$_.index,
          e = _a$customDataEvents$_.valuesCountMap;
        b.has(d) || b.set(d, _construct(CustomData, [d].concat(_toConsumableArray(Object.keys(e)))));
      }
    }
  }]);
}();
exports.CustomData = CustomData;